<template>
  <v-card class="elevation-0 shadow white mt-3 pb-3 flex mt-3">
    <v-card-text>
      <div class="flex-row mb-2 align-center justify-start">
        <div class="py-2 px-3 lable-out">
          <h3>{{ $t("income_statement") }}</h3>
        </div>
        <v-spacer />
        <v-btn
          color="grey darken-2"
          class="ml-0"
          flat
          icon
          @click="printTable(false)"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          color="grey darken-2"
          class="mx-0"
          flat
          icon
          @click="printTable(true)"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </div>
      <v-data-table
        hide-actions
        :headers="headers"
        :hide-headers="external"
        :items="computed_customers"
      >
        <template slot="items" slot-scope="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ $t(item.type) }}</td>
            <td>{{ item.code }}</td>
            <td>{{ $t(item.name) }}</td>
            <td
              v-for="currency in computedCurrencies"
              :key="`${index}${currency.id}`"
              class="font-weight-bold"
              :class="{
                'red--text': item[currency.id] < 0,
                'activeColor--text': item[currency.id] > 0,
              }"
            >
              <span v-if="currency.id == afn_currency_id">
                {{
                  item[currency.id]
                    | currency({ symbol: smbl(afn_currency_id) })
                }}
              </span>
              <span v-else>
                {{
                  item[currency.id + "_to_base"]
                    | currency({ symbol: smbl(base_currency_id) })
                }}
              </span>
            </td>
            <td class="font-weight-bold">
              {{ sumToAfn(item) | currency({ symbol: smbl(afn_currency_id) }) }}
            </td>
          </tr>
        </template>
        <template slot="footer">
          <tr>
            <td colspan="4" class="font-weight-medium body-2">
              {{ total.income.type }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              class="font-weight-medium body-2"
              :key="`income${currency.id}`"
            >
              <span v-if="currency.id == afn_currency_id">
                {{
                  total.income[currency.id]
                    | currency({ symbol: smbl(currency.id) })
                }}
              </span>
              <span v-else>
                {{
                  total.income[currency.id + "_to_base"]
                    | currency({ symbol: smbl(base_currency_id) })
                }}
              </span>
            </td>
            <td class="font-weight-bold">
              {{
                sumToAfn(total.income)
                  | currency({ symbol: smbl(afn_currency_id) })
              }}
            </td>
          </tr>
          <tr>
            <td colspan="4" class="font-weight-medium body-2">
              {{ total.expense.type }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              :key="`expense${currency.id}`"
              class="font-weight-medium body-2"
              :class="{
                'activeColor--text': total.expense[currency.id] > 0,
              }"
            >
              <span v-if="currency.id == afn_currency_id">
                {{
                  total.expense[currency.id]
                    | currency({ symbol: smbl(currency.id) })
                }}
              </span>
              <span v-else>
                {{
                  total.expense[currency.id + "_to_base"]
                    | currency({ symbol: smbl(base_currency_id) })
                }}
              </span>
            </td>
            <td class="font-weight-bold">
              {{
                sumToAfn(total.expense)
                  | currency({ symbol: smbl(afn_currency_id) })
              }}
            </td>
          </tr>
          <tr>
            <td colspan="4" class="font-weight-medium body-2">
              {{ total.net_income.type }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              :key="`net_income${currency.id}`"
              class="font-weight-medium body-2"
              :class="{
                'red--text': total.net_income[currency.id] < 0,
                'activeColor--text': total.net_income[currency.id] > 0,
              }"
            >
              <span v-if="currency.id == afn_currency_id">
                {{
                  total.net_income[currency.id]
                    | currency({ symbol: smbl(currency.id) })
                }}
              </span>
              <span v-else>
                {{
                  total.net_income[currency.id + "_to_base"]
                    | currency({ symbol: smbl(base_currency_id) })
                }}
              </span>
            </td>
            <td class="font-weight-bold">
              {{
                sumToAfn(total.net_income)
                  | currency({ symbol: smbl(afn_currency_id) })
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import curjs from "currency.js";
import { exchange } from "@/mixins/index.js";

export default {
  mixins: [exchange],
  props: {
    title: "",
    brnch_name:"",
    rates: {
      default: () => {},
    },
    showFilter: false,
    customers: { default: () => [] },
    currencies: { default: () => [] },
    external: { default: () => false },
  },
  data: () => ({
    talab: false,
    base_currency_id: 1,
    selected_currencies: null,
  }),
  computed: {
    computedCurrencies: (vm) =>
      vm.selected_currencies ? [vm.selected_currencies] : vm.currencies,
    headers() {
      let items = [
        {
          text: this.$t("number"),
          sortable: false,
          width: "50px",
        },
        {
          value: "type",
          width: "120px",
          sortable: false,
          text: this.$t("type"),
          computed: (item) => this.$t(item.type),
        },
        {
          value: "code",
          width: "200px",
          sortable: false,
          text: this.$t("code"),
        },
        {
          value: "name",
          width: "200px",
          sortable: false,
          text: this.$t("name"),
          computed: (item) => this.$t(item.name),
        },
      ];
      this.computedCurrencies.forEach((item) => {
        let va = item.id;
        items.push({
          text: item.name,
          sortable: false,
          value: va,
          item_class: "font-weight-bold",
          computed: (ite) =>
            va == this.afn_currency_id
              ? `${curjs(ite[va]).format({ symbol: "" })} ${this.smbl(
                  this.afn_currency_id
                )}`
              : `${curjs(ite[va + "_to_base"]).format({
                  symbol: "",
                })} ${this.smbl(this.base_currency_id)}`,
        });
      });
      // items.push({
      //   text: "USD Equivalent",
      //   sortable: false,
      //   item_class: "font-weight-bold",
      //   computed: (item) =>
      //     `${this.sumToUSD(item)} ${this.smbl(this.base_currency_id)}`,
      // });

      items.push({
        text: "AFN Equivalent",
        sortable: false,
        item_class: "font-weight-bold",
        computed: (item) =>
          `${this.sumToAfn(item)} ${this.smbl(this.afn_currency_id)}`,
      });
      return items;
    },

    computed_customers() {
      if (this.selected_currencies)
        return this.customers.filter((x) => {
          if (this.talab) return x[this.selected_currencies.id] > 0;
          return x[this.selected_currencies.id] < 0;
        });
      else return this.customers;
    },

    total() {
      let headers = this.headers;
      let income = {
        class: "font-weight-bold",
        type: this.$t("total_income"),
      };
      let expense = {
        type: this.$t("total_expense"),
        class: "font-weight-bold",
      };
      let net_income = {
        type:this.$t('net_income'),
        class: "font-weight-bold",
      };

      this.computed_customers.forEach((item) => {
        this.computedCurrencies.forEach((currency) => {
          if (item.type == "expense") {
            expense[currency.id] = curjs(expense[currency.id] || 0).add(
              item[currency.id]
            );
            net_income[currency.id] = curjs(
              net_income[currency.id] || 0
            ).subtract(item[currency.id]);

            expense[currency.id + "_to_base"] = curjs(
              expense[currency.id + "_to_base"] || 0
            ).add(item[currency.id + "_to_base"]);
            net_income[currency.id + "_to_base"] = curjs(
              net_income[currency.id + "_to_base"] || 0
            ).subtract(item[currency.id + "_to_base"]);
          } else if (item.type == "income") {
            income[currency.id] = curjs(income[currency.id] || 0).add(
              item[currency.id]
            );
            net_income[currency.id] = curjs(net_income[currency.id] || 0).add(
              item[currency.id]
            );

            income[currency.id + "_to_base"] = curjs(
              income[currency.id + "_to_base"] || 0
            ).add(item[currency.id + "_to_base"]);
            net_income[currency.id + "_to_base"] = curjs(
              net_income[currency.id + "_to_base"] || 0
            ).add(item[currency.id + "_to_base"]);
          }
        });
      });
      return { income, expense, net_income };
    },
  },

  methods: {
    sumToAfn(item) {
      let total = 0;
      let rates = this.rates;
      // defiend in bootstrapjs
      let base_currency = rates[this.base_currency_id] || {
        rank: 2,
        name: "",
        rate: 1,
      };
      let afnCurrency = rates[this.afn_currency_id] || {
        rank: 3,
        name: "",
        rate: 1,
      };

      this.currencies.forEach((currency) => {
        let cr = rates[currency.id] ? rates[currency.id].rate : 1;
        let rate = this.getRate(
          currency.rank,
          afnCurrency.rank,
          base_currency.rank,
          cr,
          afnCurrency.rate
        );
        total = curjs(total).add(
          this.exchange(currency, afnCurrency, item[currency.id], rate)
        );
      });
      return total;
    },
    sumToUSD(item) {
      // total_in_usd
      let total = 0;
      let rates = this.rates;
      // defiend in bootstrapjs
      let base_currency = rates[this.base_currency_id] || {
        rank: 2,
        name: "",
        rate: 1,
      };
      // let afnCurrency = rates[this.afn_currency_id] || {
      //   rank: 3,
      //   name: "",
      //   rate: 1,
      // };

      this.currencies.forEach((currency) => {
        // comes from mixin
        let cr = rates[currency.id] ? rates[currency.id].rate : 1;
        // let rate = this.getRate(
        //   currency.rank,
        //   afnCurrency.rank,
        //   base_currency.rank,
        //   cr,
        //   afnCurrency.rate
        // );
        total = curjs(total).add(
          this.exchange(currency, base_currency, item[currency.id], cr)
        ).value;
      });
      return total;
    },
    getTotal(item) {
      let baseCurrency = this.currencies.find((x) => x.id == 1);
      let total = 0;
      this.computedCurrencies.forEach((currency) => {
        if (item[currency.id]) {
          let c = this.exchange(
            currency,
            baseCurrency,
            item[currency.id],
            this.rates[currency.id]
          );
          total = curjs(total).add(c);
        }
      });
      return total;
    },
    printTable(excel) {
      let items = this.computed_customers;
      items.push(this.total.income, this.total.expense, this.total.net_income);

      let data = {
        items: items,
        landscape: true,
        title: this.title,
        brnch_name: this.brnch_name,
        headers: this.headers.slice(1),
      };

      if (excel)
        return this.xl_tables(data, "customersAccounts", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
};
</script>
 